import { i18n } from '@/plugins/i18n'
import PriorityColumn from './../components/priority-column'
import statusColumn from './../components/status-column'

const priorityTemplate = (row, index, datatable) => {
    let template = new PriorityColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}

const statusTemplate = (row, index, datatable) => {
    let template = new statusColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}

export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 50,
        type: 'number',
        selector: false,
        textAlign: 'center',
    },
    {
        field: 'subject',
        title: i18n.t('label.subject'),
        sortable: true,
        width: 90,
        textAlign: 'center',
    },
    {
        field: 'category',
        title: i18n.t('label.category'),
        sortable: true,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'priority',
        title: i18n.t('label.priority'),
        template: (row, index, datatable) => {
            return priorityTemplate(row, index, datatable)
        },
        sortable: true,
        width: 70,
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'status',
        title: i18n.t('label.status'),
        template: (row, index, datatable) => {
            return statusTemplate(row, index, datatable)
        },
        sortable: true,
        width: 90,
        textAlign: 'center',
    },
]